{
  "dashboard": "Tableau de bord de l'auditeur",
  "assignments": "Missions",
  "reviews": "Examens",
  "sidebar": {
    "dashboard": "Tableau de bord",
    "assigned_projects": "Projets assignés",
    "verification_reports": "Rapports de vérification",
    "validation_schedule": "Calendrier de validation",
    "settings": "Paramètres"
  },
  "dashboard_page": {
    "title": "Tableau de bord de l'auditeur",
    "subtitle": "Gérer les validations de projets et les rapports de vérification",
    "stats": {
      "assigned_projects": "Projets assignés",
      "pending_reviews": "Examens en attente",
      "completed_reports": "Rapports terminés",
      "validation_score": "Score de validation"
    },
    "assigned_projects": {
      "title": "Projets assignés",
      "view_all": "Voir tout",
      "validation_due": "Validation due",
      "in_progress": "En cours",
      "completed": "Terminé",
      "due": "Dû",
      "started": "Commencé"
    },
    "validation_status": {
      "title": "Statut de validation",
      "projects_validated": "Projets validés",
      "reports_submitted": "Rapports soumis",
      "compliance_rate": "Taux de conformité"
    },
    "recent_reports": {
      "title": "Rapports de vérification récents",
      "upload_report": "Télécharger le rapport",
      "project": "Projet",
      "type": "Type",
      "status": "Statut",
      "date": "Date",
      "actions": "Actions",
      "validation_report": "Rapport de validation",
      "verification_report": "Rapport de vérification",
      "approved": "Approuvé",
      "under_review": "En cours d'examen"
    },
    "quick_actions": {
      "title": "Actions rapides",
      "upload_report": {
        "title": "Télécharger le rapport",
        "description": "Soumettre le rapport de vérification"
      },
      "schedule_validation": {
        "title": "Planifier la validation",
        "description": "Réserver l'évaluation du projet"
      },
      "update_declaration": {
        "title": "Mettre à jour la déclaration",
        "description": "Modifier la déclaration d'impartialité"
      }
    }
  },
  "register_page": {
    "breadcrumb": {
      "home": "Accueil",
      "registration": "Inscription",
      "auditor_registration": "Inscription de l'auditeur"
    },
    "hero": {
      "title": "Inscription de l'auditeur",
      "subtitle": "Accréditation de l'entité opérationnelle désignée (EOD)",
      "registration_fee": "Frais d'inscription : 3 000,00 $"
    },
    "form": {
      "title": "Formulaire d'inscription EOD",
      "subtitle": "Remplissez tous les champs obligatoires pour vous inscrire en tant qu'entité opérationnelle désignée",
      "step_progress": "Étape 1 sur 3",
      "entity_information": {
        "title": "Informations sur l'entité",
        "entity_name": "Nom de l'entité",
        "entity_name_placeholder": "Entrez le nom légal de l'entité",
        "country": "Pays de constitution",
        "select_country": "Sélectionner le pays",
        "registration_number": "Numéro d'enregistrement",
        "registration_number_placeholder": "Entrez le numéro d'enregistrement légal",
        "contact_email": "E-mail de contact",
        "contact_email_placeholder": "par ex. contact{'@'}entity.com",
        "phone_number": "Numéro de téléphone",
        "phone_number_placeholder": "par ex. +1 (555) 123-4567",
        "website": "Site Internet",
        "website_placeholder": "par ex. https://www.entity.com",
        "address": "Adresse physique",
        "address_placeholder": "Entrez l'adresse physique complète"
      },
      "accreditation_details": {
        "title": "Détails de l'accréditation",
        "accreditation_body": "Organisme d'accréditation",
        "select_body": "Sélectionner l'organisme d'accréditation",
        "accreditation_number": "Numéro d'accréditation",
        "accreditation_number_placeholder": "Numéro du certificat d'accréditation",
        "valid_until": "Accréditation valide jusqu'au",
        "iso_standard": "Norme ISO",
        "select_iso": "Sélectionner la norme ISO"
      },
      "sectoral_scope": {
        "title": "Sélection du champ d'application sectoriel",
        "info_title": "Sélectionnez vos domaines d'expertise",
        "info_description": "Choisissez tous les champs d'application sectoriels pour lesquels votre entité dispose d'une accréditation et d'une expertise pour valider les projets de crédits carbone.",
        "energy_renewable": "Énergie (renouvelable)",
        "energy_renewable_desc": "Solaire, éolien, hydraulique",
        "energy_efficiency": "Efficacité énergétique",
        "energy_efficiency_desc": "Bâtiments, industrie",
        "transport": "Transport",
        "transport_desc": "Changement de mode, efficacité",
        "manufacturing": "Fabrication",
        "manufacturing_desc": "Optimisation des processus",
        "chemical_industry": "Industrie chimique",
        "chemical_industry_desc": "Émissions de processus",
        "construction": "Construction",
        "construction_desc": "Matériaux, méthodes",
        "mining_mineral": "Mines/Minéraux",
        "mining_mineral_desc": "Extraction, traitement",
        "metal_production": "Production de métaux",
        "metal_production_desc": "Acier, aluminium",
        "fugitive_emissions": "Émissions fugitives",
        "fugitive_emissions_desc": "Pétrole, gaz, charbon",
        "solvents": "Solvants",
        "solvents_desc": "Usage industriel",
        "waste_management": "Gestion des déchets",
        "waste_management_desc": "Élimination, traitement",
        "afolu": "AFOLU",
        "afolu_desc": "Agriculture, foresterie",
        "chemical_industry_placeholder": "par ex. Production d'acide nitrique",
        "construction_placeholder": "par ex. Production de ciment",
        "mining_mineral_placeholder": "par ex. Exploitation minière du charbon",
        "metal_production_placeholder": "par ex. Production de fer et d'acier",
        "fugitive_emissions_placeholder": "par ex. Méthane du gaz naturel",
        "solvents_placeholder": "par ex. Application de peinture",
        "waste_management_placeholder": "par ex. Récupération des gaz de décharge"
      },
      "documents": {
        "title": "Documents requis",
        "accreditation_certificate": "Certificat d'accréditation",
        "risk_framework": "Cadre de gestion des risques",
        "declaration_impartiality": "Déclaration d'impartialité",
        "upload_instructions": "Cliquez pour télécharger ou glisser-déposer",
        "file_requirements": "PDF, max 10 Mo"
      },
      "declarations": {
        "title": "Déclarations et conditions"
      }
    }
  }
}